import { NavLink } from "react-router-dom";
import contactIcon from "../../assets/images/Icons-03.svg";
import documentIcon from "../../assets/images/Icons-02.svg";
import emailIcon from "../../assets/images/Icons-01.svg";
import adminIcon from "../../assets/images/Icons-04.svg";

const TopMenuStrip = () => {
  return (
    <div
      className="dropdown custom-dropdown-new col-sm-12"
      style={{ borderBottom: "3px solid gainsboro" }}
    >
      <div className="row">
        <div className="col-md-6" style={{ paddingLeft: 0 }}>

          <MenuItem to="/AdminContact" icon={contactIcon} label="Contacts" />
          <MenuItem to="/AdminDocument" icon={documentIcon} label="Documents" />
          <MenuItem to="/Email" icon={emailIcon} label="Emails" />
          <MenuItem to="/WebUserAdmin" icon={adminIcon} label="Admin" />

        </div>
      </div>
    </div>
  );
};

const MenuItem = ({ to, icon, label }) => (
  <div className="col-sm-2" style={{ textAlign: "center" }}>
    <NavLink to={to}>
      {({ isActive }) => (
        <>
          <img
            src={icon}
            className="crmicon"
            style={{
              opacity: isActive ? 1 : 0.5,
              padding: "2px"
            }}
            alt={label}
          />
          <br />
          <label>{label}</label>
        </>
      )}
    </NavLink>
  </div>
);

export default TopMenuStrip;